<script>
    import Merch from "./Merch.svelte";
    import { static_page } from "../stores/store.js";
    import { slide } from "svelte/transition";
    import Drops from "./Drops.svelte";
    import Radio from "./Radio.svelte";

    const pages = { merch: Merch, drops: Drops, radio: Radio };
</script>

{#key $static_page}
    <div class="p-2 h-full w-full" transition:slide>
        <h2 class="text-fuchsia-400 capitalize text-3xl mb-4">
            {$static_page}
        </h2>
        <svelte:component this={pages[$static_page]} />
    </div>
{/key}
